import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./myToolkit.css";
import BeforeFooter from '../components/layout/BeforeFooter';
import toolsIcon from '../assets/toolkit.png';

const tools = [
  {
    id: 'phone',
    emoji: '📱',
    title: 'iPhone',
    className: 'phone',
    body: 'My iPhone goes everywhere with me. I rely on Notes for quick captures and Reminders to keep things from slipping through the cracks.',
  },
  {
    id: 'laptop',
    emoji: '💻',
    title: 'MacBook',
    className: 'laptop',
    body: 'My main machine. The M4 chip makes it fast enough for everything I throw at it — coding, design, data work — while staying portable.',
  },
  {
    id: 'pc',
    emoji: '🖥️',
    title: 'HP PC',
    className: 'coding',
    body: 'A Windows desktop I keep around for heavier tasks or when I need a second screen setup. Useful to have both worlds.',
  },
  {
    id: 'headphones',
    emoji: '🎧',
    title: 'AirPods',
    className: 'headphones',
    body: 'Always in my ears during coding sessions and music. The wireless freedom makes them hard to put down.',
  },
  {
    id: 'journals',
    emoji: '📓',
    title: 'Journals & Pen',
    className: 'journal',
    body: (
      <>
        <p>Three journals, each with a job:</p>
        <ul>
          <li>A small one for morning brain dumps</li>
          <li>One for goals, planning & tracking</li>
          <li>One for freely writing my thoughts</li>
        </ul>
        <p>A pen is always within reach — some things just need paper.</p>
      </>
    ),
  },
  {
    id: 'productivity',
    emoji: '🛠️',
    title: 'Productivity',
    className: 'apps',
    body: 'Notion for organizing everything digitally, and Canva for anything visual — presentations, posts, and social graphics.',
  },
  {
    id: 'coding',
    emoji: '⌨️',
    title: 'Coding Setup',
    className: 'coding2',
    body: (
      <>
        <p>VS Code for most projects, PyCharm for Python-heavy work, and Google Colab for data science. Terminal-wise, I use{' '}
          <a href="https://iterm2.com" target="_blank" rel="noreferrer">iTerm2</a>.
        </p>
      </>
    ),
  },
  {
    id: 'book',
    emoji: '📖',
    title: 'Currently Reading',
    className: 'book',
    body: (
      <>
        Always a book on the side.{' '}
        <a
          href="https://www.amazon.com/Art-Loving-Erich-Fromm/dp/0061129739"
          target="_blank"
          rel="noreferrer"
        >
          The Art of Loving
        </a>{' '}
        is the current one.
      </>
    ),
  },
];

function MyToolkit() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      {/* HERO */}
      <section className="toolkit-hero">
        <div className="toolkit-hero-text">
          <h1>My Toolkit</h1>
          <p>
            A peek into the gadgets, apps, and tools I use daily for coding,
            designing, and staying productive.
          </p>
        </div>
        <div className="toolkit-hero-img">
          <img src={toolsIcon} alt="toolkit illustration" />
        </div>
      </section>

      {/* TOOLS GRID */}
      <section className="toolkit-grid-section">
        <h2 className="toolkit-grid-title">My Favorite Tools</h2>
        <div className="toolkit-grid">
          {tools.map((tool, index) => (
            <div
              key={tool.id}
              className={`toolkit-card ${tool.className}`}
              data-aos="fade-up"
              data-aos-delay={index * 60}
            >
              <span className="toolkit-icon">{tool.emoji}</span>
              <h3>{tool.title}</h3>
              {typeof tool.body === 'string' ? (
                <p>{tool.body}</p>
              ) : (
                <div className="toolkit-card-rich">{tool.body}</div>
              )}
            </div>
          ))}
        </div>
      </section>

      <BeforeFooter />
    </>
  );
}

export default MyToolkit;